import script from "./trackedDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./trackedDetail.vue?vue&type=script&setup=true&lang=ts"

import "./trackedDetail.vue?vue&type=style&index=0&id=6940468e&lang=scss&scoped=true"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6940468e"]])

export default __exports__